module.exports = __webpack_public_path__ + "img/아주경제.7b93b211.png";